import React from 'react';
import PropTypes from 'prop-types';
import styles from './OnboardingUL.scss';

/**
 * Displays custom unordered lists. Used to display terms of service and
 * privacy policy summary lists.
 */
const OnboardingUL = ({ children }) => {
  return <ul className={styles.list}>{children}</ul>;
};

OnboardingUL.propTypes = {
  children: PropTypes.node.isRequired
};

export default OnboardingUL;
